var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { attrs: { name: "query-sort-block" } },
      [
        _c("swb-goods-ship-voucher-search", {
          ref: "query_model",
          on: { showSearch: _vm.searchMethod }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.checkActionPerm("to_ship") &&
    ((_vm.currGoodsOrderId != null && !_vm.currCancelledFlag) ||
      _vm.currGoodsOrderId == null)
      ? _c("div", { staticClass: "simple-row" }, [
          _c("div", { staticClass: "left" }, [
            _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.toGoodsShipCreate()
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.currGoodsOrderId == null ? "新增发货单" : "发货")
                )
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.goodsShipVoucherList,
              border: "",
              height: _vm.domHeight
            }
          },
          [
            _c("el-table-column", {
              attrs: { prop: "no", label: "发货单号", width: "180" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _vm.checkActionPerm("view_detail")
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.showShipInfoDlg(rows.row.id)
                                }
                              }
                            },
                            [_vm._v(_vm._s(rows.row.no))]
                          )
                        : _c("span", [_vm._v(_vm._s(rows.row.no))])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "订单号", width: "180" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _vm.checkActionPerm("to_order_list")
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.toGoodsOrderInfo(rows.row.goodsOrder.id)
                                }
                              }
                            },
                            [_vm._v(_vm._s(rows.row.orderNo))]
                          )
                        : _c("span", [_vm._v(_vm._s(rows.row.orderNo))])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "buyerName",
                label: "买家名称",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "buyerShopName",
                label: "买家业务单元",
                width: "150",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "buyerBizUnitName",
                label: "买家所属部门",
                width: "150",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "logisExpNo",
                label: "物流单号",
                width: "140",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "logisFee",
                label: "物流费用(元)",
                width: "120",
                align: "right"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.logisFee != null
                        ? _c("span", [
                            _vm._v(_vm._s(rows.row.logisFee.toFixed(2)))
                          ])
                        : _c("span", [_vm._v("0.00")])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "amount",
                label: "商品金额(元)",
                width: "120",
                align: "right"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.amount != null
                        ? _c("span", [
                            _vm._v(_vm._s(rows.row.amount.toFixed(2)))
                          ])
                        : _c("span", [_vm._v("0.00")])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "confirmed", label: "状态", width: "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.invalid == 0
                        ? _c("div", [
                            rows.row.receiveState == 1
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        staticStyle: {
                                          "background-color": "transparent",
                                          border: "none"
                                        },
                                        attrs: {
                                          type: "success",
                                          "close-transition": ""
                                        }
                                      },
                                      [_vm._v("已部分收货")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            rows.row.receiveState == 2
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        staticStyle: {
                                          "background-color": "transparent",
                                          border: "none"
                                        },
                                        attrs: {
                                          type: "success",
                                          "close-transition": ""
                                        }
                                      },
                                      [_vm._v("已全部收货")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            rows.row.receiveState == -1
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        staticStyle: {
                                          "background-color": "transparent",
                                          border: "none"
                                        },
                                        attrs: {
                                          type: "success",
                                          "close-transition": ""
                                        }
                                      },
                                      [_vm._v("已拒收")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            rows.row.receiveState == 0
                              ? _c(
                                  "div",
                                  [
                                    rows.row.confirmed == true
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticStyle: {
                                              "background-color": "transparent",
                                              border: "none"
                                            },
                                            attrs: {
                                              type: "success",
                                              "close-transition": ""
                                            }
                                          },
                                          [_c("span", [_vm._v("已发货")])]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    rows.row.confirmed == false
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticStyle: {
                                              "background-color": "transparent",
                                              border: "none"
                                            },
                                            attrs: {
                                              type: "danger",
                                              "close-transition": ""
                                            }
                                          },
                                          [_c("span", [_vm._v("未发货")])]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      rows.row.invalid == 1
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-tag",
                                {
                                  staticStyle: {
                                    "background-color": "transparent",
                                    border: "none"
                                  },
                                  attrs: {
                                    type: "danger",
                                    "close-transition": ""
                                  }
                                },
                                [_vm._v("已作废")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "confirmTime",
                label: "发货确认时间",
                width: "160",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "senderContactName",
                label: "发货人",
                width: "130",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "senderContactTel",
                label: "发货人联系方式",
                width: "130",
                align: "center",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "shipProxied",
                label: "委托发货",
                width: "80",
                align: "center"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(rows.row.shipProxied ? "是" : "否"))
                      ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "id", label: "操作", width: "180" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _vm.checkActionPerm("confirm_ship") &&
                      !rows.row.confirmed &&
                      !rows.row.invalid &&
                      !rows.row.shipProxied
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.toConfirmedShip(rows.row.id)
                                }
                              }
                            },
                            [_vm._v("确认发货")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkActionPerm("view_detail")
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.showShipInfoDlg(rows.row.id)
                                }
                              }
                            },
                            [_vm._v("查看")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !rows.row.shipProxied &&
                      _vm.checkActionPerm("invalidate") &&
                      (rows.row.confirmed == false ||
                        rows.row.receiveState == -1) &&
                      rows.row.invalid == 0
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.invalidShipInfoDlg(rows.row.id)
                                }
                              }
                            },
                            [_vm._v("作废")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      rows.row.shipProxied &&
                      _vm.checkActionPerm("invalidate") &&
                      rows.row.invalid == 0 &&
                      (rows.row.shipRspState == -1 || !rows.row.shipReqSent)
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.invalidShipInfoDlg(rows.row.id)
                                }
                              }
                            },
                            [_vm._v("作废")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkActionPerm("apply") &&
                      !rows.row.invalid &&
                      rows.row.shipProxied &&
                      !rows.row.shipReqSent
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.doShipReqSent(rows.row.id)
                                }
                              }
                            },
                            [_vm._v("委托请求")]
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pagination-layout" },
      [
        _vm.totalCount > 0
          ? _c("el-pagination", {
              attrs: {
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                "page-size": _vm.pageSize,
                "page-sizes": _vm.pageSizes,
                "current-page": _vm.pageNumber,
                total: _vm.totalCount
              },
              on: {
                "current-change": _vm.handlePageChange,
                "size-change": _vm.handleSizeChange
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1949542c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1949542c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsShipVoucherList.vue
// module id = 1834
// module chunks = 1